import { Check, Clock, X } from "lucide-react";

export type EstadoConfirmacion = "pendiente" | "confirmado" | "declinado";

export function isOverdue(createdAt: string | null | undefined) {
  if (!createdAt) return false;
  const created = new Date(createdAt).getTime();
  return Date.now() - created > 48 * 60 * 60 * 1000;
}

export function EventStatusBadge({
  estado,
  createdAt,
  showDeclined = false,
  size = "sm",
}: {
  estado: EstadoConfirmacion | null | undefined;
  createdAt?: string | null;
  showDeclined?: boolean;
  size?: "sm" | "md";
}) {
  if (!estado) return null;
  if (estado === "declinado" && !showDeclined) return null;

  const px = size === "md" ? "px-3 py-1.5 text-xs" : "px-2.5 py-1 text-[11px]";
  const base = `inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wider ${px}`;

  if (estado === "confirmado") {
    return (
      <span className={`${base} bg-emerald-500/15 border border-emerald-500/40 text-emerald-400`}>
        <Check className="w-3.5 h-3.5" />
        Local confirmado
      </span>
    );
  }
  if (estado === "declinado") {
    return (
      <span className={`${base} bg-red-500/15 border border-red-500/40 text-red-400`}>
        <X className="w-3.5 h-3.5" />
        Declinado
      </span>
    );
  }
  // pendiente
  const overdue = isOverdue(createdAt);
  return (
    <span className={`${base} bg-amber-500/15 border border-amber-500/40 text-amber-400`}>
      <Clock className="w-3.5 h-3.5" />
      {overdue ? "Confirmación pendiente" : "Pendiente de confirmación"}
    </span>
  );
}
